// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__173Kz","sendOtp":"AuthorizeToLogin_sendOtp__2QrBM"};